import { Pipe } from '@angular/core';
var CeilPipe = (function () {
    function CeilPipe() {
    }
    CeilPipe.prototype.transform = function (num, precision) {
        if (precision === void 0) { precision = 0; }
        if (precision <= 0) {
            return Math.ceil(num);
        }
        var tho = Math.pow(10, precision);
        return Math.ceil(num * tho) / tho;
    };
    return CeilPipe;
}());
export { CeilPipe };
CeilPipe.decorators = [
    { type: Pipe, args: [{ name: 'ceil' },] },
];
/** @nocollapse */
CeilPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=ceil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/ceil.js
// module id = 235
// module chunks = 4